import React from 'react'
import CloseIcon from '@mui/icons-material/Close'
import { Backdrop, Box, IconButton, Paper, Typography } from '@mui/material'
import { noop } from 'lodash'
import PropTypes from 'prop-types'

function ImageModal({ title, imageUrl, isOpen, onClose }) {
  const handleClose = (e) => {
    e.preventDefault()
    onClose()
  }

  return isOpen ? (
    <Backdrop open={isOpen} sx={{ zIndex: 999 }}>
      <Paper elevation={0}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-end',
            p: 2,
          }}
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              width: '100%',
            }}
          >
            <Typography variant="body1">{title}</Typography>
            <IconButton onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </Box>
          <img
            src={imageUrl}
            alt=""
            style={{ maxHeight: '80vh', maxWidth: '80vw' }}
          />
        </Box>
      </Paper>
    </Backdrop>
  ) : null
}

ImageModal.propTypes = {
  title: PropTypes.string,
  imageUrl: PropTypes.string,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
}
ImageModal.defaultProps = {
  title: null,
  imageUrl: '',
  isOpen: false,
  onClose: noop,
}
export default ImageModal
